import * as S from './RegisterEvent.styles'
import {
  Heading,
  Paragraph,
  Input,
  Button,
  AlertModal,
  RadioButton
} from 'applaus-ui-kit'
import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { registerEvent } from '../../../../redux/Events/actions'
import {
  createEventSchema,
  createEventSchemaWithCashback
} from './validationSchema'
import { ReduxState } from '../../../../redux/rootReducer'
import { ImageSelector } from './Components/ImageSelector'
import Select, { GroupBase } from 'react-select'
import { listSeatMapService } from '../../../../api/seatMap/listSeatMapServices'
import { history } from '../../../../routes/services/history'
import { CurrencyInput } from '../../../../components/CurrencyInput/CurrencyInput'
import { AgeGroupSelect } from '../../../../components/AgeGroupSelect/AgeGroupSelect'

type AlertModalTypes = {
  message: string
  description?: string
  open: boolean
  variant: 'error' | 'success'
}
type OptionType = {
  value: string
  label: string
}

declare module 'react-select/dist/declarations/src/Select' {
  export interface Props<
    Option,
    // eslint-disable-next-line no-unused-vars
    IsMulti extends boolean,
    // eslint-disable-next-line no-unused-vars
    Group extends GroupBase<Option>
  > {}
}

type ErrorState = {
  error: boolean
  message: string
}

export const RegisterEvent = () => {
  const [options, setOptions] = useState<OptionType[]>([])
  const [mappedEvent, setMappedEvent] = useState(true)
  const [mobilePreview, setMobilePreview] = useState('')
  const [tabletPreview, setTabletPreview] = useState('')
  const [cardPreview, setCardPreview] = useState('')
  const [desktopPreview, setDesktopPreview] = useState<string>('')
  const [cashback, setCashback] = useState(false)
  const [alertModal, setAlertModal] = useState<AlertModalTypes>({
    open: false,
    message: '',
    variant: 'error'
  })
  const [errorCard, setErrorCard] = useState<ErrorState>({
    error: false,
    message: ''
  })
  const [errorMobile, setErrorMobile] = useState<ErrorState>({
    error: false,
    message: ''
  })
  const [errorTablet, setErrorTablet] = useState<ErrorState>({
    error: false,
    message: ''
  })
  const [errorDesktop, setErrorDesktop] = useState<ErrorState>({
    error: false,
    message: ''
  })
  const categoryOptions = [
    {
      label: 'Shows',
      value: 'Shows'
    },
    {
      label: 'Eventos online',
      value: 'Eventos online'
    },
    {
      label: 'Esportes',
      value: 'Esportes'
    },
    {
      label: 'Palestras',
      value: 'Palestras'
    },
    {
      label: 'Teatro',
      value: 'Teatro'
    }
  ]
  const [selectedCategory, setSelectedCategory] = useState('Shows')
  const dispatch = useDispatch()
  const { manageEvent } = useSelector((state: ReduxState) => state.EventReducer)

  const formik = useFormik({
    initialValues: {
      name: '',
      ageGroup: '',
      cashback: '',
      desktopUrl: '',
      tabletUrl: '',
      mobileUrl: '',
      cardUrl: '',
      seatMapId: ''
    },
    validationSchema: cashback
      ? createEventSchemaWithCashback
      : createEventSchema,
    onSubmit: (values) => {
      if (mappedEvent && values.seatMapId === '') {
        setAlertModal({
          variant: 'error',
          message: 'Selecione o mapa do evento mapeado',
          open: true
        })
      } else {
        dispatch(
          registerEvent({
            name: values.name,
            ageGroup: formik.values.ageGroup,
            category: selectedCategory,
            cashBackPercent: !cashback
              ? undefined
              : values.cashback !== String(0) && values.cashback !== ''
              ? Number(values.cashback)
              : undefined,
            banners: [
              {
                desktopUrl: values.desktopUrl,
                tabletUrl: values.tabletUrl,
                mobileUrl: values.mobileUrl,
                cardUrl: values.cardUrl
              }
            ],
            type: mappedEvent ? 'MAPPED' : 'TABULATED',
            seatMapId: mappedEvent ? formik.values.seatMapId : undefined
          })
        )
      }
    }
  })

  const fetchSeatMaps = async () => {
    try {
      const data = await listSeatMapService()
      setOptions(
        data.map((value) => ({
          label: value.name,
          value: value.id
        }))
      )
    } catch (e) {}
  }

  const handleSetField = (name: string, file: File | '') => {
    formik.setFieldValue(name, file)
  }

  useEffect(() => {
    fetchSeatMaps()
    if (manageEvent) {
      formik.setFieldValue('name', manageEvent.name)
      formik.setFieldValue('seatMapId', manageEvent.name)
      formik.setFieldValue('ageGroup', manageEvent.ageGroup)
      setSelectedCategory(manageEvent.category)
      if (manageEvent.banners) {
        setDesktopPreview(manageEvent.banners[0]?.desktopUrl as string)
        setMobilePreview(manageEvent.banners[0]?.mobileUrl as string)
        setTabletPreview(manageEvent.banners[0]?.tabletUrl as string)
        setCardPreview(manageEvent.banners[0]?.cardUrl as string)
      }
    }
  }, [])

  const handleAgeGroupChange = (e: { value: string; label: string }) => {
    formik.setFieldValue('ageGroup', e.value)
  }

  return (
    <S.Container>
      <S.Wrapper>
        <S.TitleBox>
          <S.BackIcon onClick={() => history.push('/events')} />
          <Heading variant="h3">Informações básicas</Heading>
        </S.TitleBox>
        <Paragraph variant="large">
          Adicione as principais informações do evento
        </Paragraph>

        <S.Form onSubmit={formik.handleSubmit}>
          <Input
            placeholder="Nome do evento"
            label="*Nome do evento"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            className="eventNameInput"
            error={formik.touched.name && Boolean(formik.errors.name)}
            texterror={formik.errors.name}
            fullWidth
          />

          <S.ChooseSectionType>
            <Paragraph variant="large" type="bold">
              Tipo de evento
            </Paragraph>
            <div className="radioButtonWrapper">
              <RadioButton
                checked={mappedEvent}
                onChange={() => setMappedEvent(true)}
                readOnly
              />
              <div className="options-text">
                <Paragraph variant="large" type="semiBold">
                  Mapeado
                </Paragraph>
                <Paragraph variant="regular">
                  O evento terá um mapa de assentos no qual o usuário escolherá
                  seu lugar
                </Paragraph>
              </div>
            </div>
            <div className="radioButtonWrapper">
              <RadioButton
                checked={!mappedEvent}
                onChange={() => setMappedEvent(false)}
                readOnly
              />
              <div className="options-text">
                <Paragraph variant="large" type="semiBold">
                  Tabelado
                </Paragraph>
                <Paragraph variant="regular">
                  Evento terá uma tabela de preços
                </Paragraph>
              </div>
            </div>
          </S.ChooseSectionType>

          {mappedEvent ? (
            <div>
              <Paragraph variant="large" type="semiBold">
                *Selecione o Mapa
              </Paragraph>

              <Select
                placeholder="Selecione o mapa"
                value={options.find(
                  (option) => option.value === formik.values.seatMapId
                )}
                options={options}
                onChange={(selectValue) => {
                  if (selectValue && selectValue.value) {
                    formik.setFieldValue('seatMapId', selectValue.value)
                  }
                }}
                noOptionsMessage={() =>
                  'Mapa não encontrado, contate o suporte'
                }
                styles={S.SelectStyle}
              />
            </div>
          ) : null}
          <S.ImageText>
            <Paragraph variant="large" type="semiBold">
              Imagem principal do evento
            </Paragraph>
            <Paragraph variant="regular">
              Esta é a primeira imagem que os participantes verão no
              <br /> início da sua página. Use uma imagem de alta qualidade
            </Paragraph>
          </S.ImageText>
          <S.ImageSelectSection>
            <ImageSelector
              name={'cardUrl'}
              selectionText={'*Card do evento'}
              imagePreview={cardPreview}
              size={'270x145px'}
              setImage={setCardPreview}
              handleSetField={handleSetField}
              previewSize={{ width: 270, height: 145 }}
              setError={setErrorCard}
              error={errorCard}
            />
            <ImageSelector
              name={'mobileUrl'}
              selectionText={'*Imagem para celular'}
              imagePreview={mobilePreview}
              size={'270x145px'}
              setImage={setMobilePreview}
              handleSetField={handleSetField}
              previewSize={{ width: 270, height: 145 }}
              setError={setErrorMobile}
              error={errorMobile}
            />
            <ImageSelector
              name={'tabletUrl'}
              selectionText={'*Imagem para Mobile'}
              imagePreview={tabletPreview}
              size={'340x283px'}
              setImage={setTabletPreview}
              handleSetField={handleSetField}
              previewSize={{ width: 340, height: 280 }}
              setError={setErrorTablet}
              error={errorTablet}
            />
            <ImageSelector
              name={'desktopUrl'}
              selectionText={'*Imagem para desktop'}
              imagePreview={desktopPreview}
              size={'418x283px'}
              setImage={setDesktopPreview}
              handleSetField={handleSetField}
              previewSize={{ width: 420, height: 280 }}
              setError={setErrorDesktop}
              error={errorDesktop}
            />
          </S.ImageSelectSection>

          <Heading variant="h3">Classifique seu evento</Heading>

          <div style={{ marginTop: '30px' }}>
            <S.Label>Classificação Etária</S.Label>
            <AgeGroupSelect
              value={formik.values.ageGroup}
              onChange={handleAgeGroupChange}
            />

            <S.Error>
              {formik.touched.ageGroup &&
                Boolean(formik.errors.ageGroup) &&
                formik.errors.ageGroup}
            </S.Error>
          </div>

          <div style={{ marginTop: '30px' }}>
            <S.Label>Categoria</S.Label>
            <Select
              placeholder="Selecione uma opção"
              options={categoryOptions}
              defaultValue={categoryOptions[0]}
              onChange={(e) => setSelectedCategory(e?.value ?? 'Shows')}
              styles={S.SelectStyle}
            />
          </div>

          <S.CashbackBox>
            <div>
              <RadioButton
                readOnly
                checked={cashback}
                onClick={() => setCashback(!cashback)}
              />
              <Heading variant="h5">Evento com Cashback</Heading>
            </div>
            {cashback ? (
              <CurrencyInput
                style={{ height: '43px' }}
                name="cashback"
                label="Porcentagem de cashback"
                error={
                  formik.touched.cashback && Boolean(formik.errors.cashback)
                }
                texterror={formik.errors.cashback}
                onChange={(e) => {
                  if (
                    e.target.value !== undefined &&
                    e.target.value.replace(/[a-zA-Z, %]/g, '').length > 0
                  ) {
                    formik.setFieldValue(
                      'cashback',
                      e.target.value.replace(/[a-zA-Z, %]/g, '')
                    )
                  }

                  if (
                    e.target.value !== undefined &&
                    e.target.value.replace(/[a-zA-Z, %]/g, '').length === 0
                  ) {
                    formik.setFieldValue('cashback', '')
                  }
                }}
                groupSeparator=","
                decimalSeparator="."
                suffix=" %"
                placeholder="Digite a % do cashback"
              />
            ) : null}
          </S.CashbackBox>
        </S.Form>
        <Button
          variant="contained"
          size="medium"
          color="primary"
          fullWidth={false}
          type="submit"
          onClick={() => formik.handleSubmit()}>
          Continuar
        </Button>
        <AlertModal
          {...alertModal}
          buttonText="Fechar"
          click={() =>
            setAlertModal({ open: false, message: '', variant: 'error' })
          }
        />
      </S.Wrapper>
    </S.Container>
  )
}
